export enum IconPosition {
  LEFT = 'start',
  RIGHT = 'end',
}
